import { SavedSearch } from 'src/data/SavedSearchApi/SavedSearchApi';
import { FiltersPayloadRow } from 'src/types/CarFilters.types';

export const handleSavedSearchApiUpdatesViaProxy = async (
  savedSearch: SavedSearch | null,
  isActive: boolean,
  filters: FiltersPayloadRow[],
  isSimilarTo: string | null,
) => {
  const res = await fetch('/api/save-searches', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ savedSearch, isActive, filters, isSimilarTo }),
  });
  return res.json();
};
